define((require) => {
    "use strict";

    const InfiniteScrollingCollectionView = require("ui/common/InfiniteScrollingCollectionView");
    const ImageLibrarySourceEnum          = require("shared/data/images/ImageLibrarySourceEnum");
    const NoResultsItemView               = require("zbone/NoResultsItemView");
    const ImageThumbnailView              = require("ui/assets/image/ImageThumbnailView");

    /**
     * A <tt>InfiniteScrollingCollectionView</tt> subclass for displaying (and lazy loading) images, i.e. <tt>ImageThumbnailView</tt>'s.
     *
     * @cfg {ImageCollection} collection The <tt>ImageCollection</tt> to render.
     *
     * @see  ImageCollection
     * @see  ImageThumbnailView
     * @see  InfiniteScrollingCollectionView
     *
     * @class ImageCollectionView
     */
    return InfiniteScrollingCollectionView.extend("ImageCollectionView", {

        itemView: ImageThumbnailView,

        collectionEvents: {
            "source:changed": "_onSourceChange"
        },

        _onSourceChange(source) {
            if (this._spinner) {
                this._spinner.$el.toggleClass("scene7", source === ImageLibrarySourceEnum.SCENE7);
            }
        },

        onEmpty() {
            return new NoResultsItemView({type: "Images"});
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/common/ImageCollectionView.js